{
    "chat": {
        "prefix": "chat",
        "nav": null
    }
}